// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Buga7","left":"styles_left__CaDxz","share":"styles_share__2RuZo","wx":"styles_wx__IEwNv","footer":"styles_footer__RvAEN"};